import { withStyles } from '@material-ui/core';
import AppBar from '@material-ui/core/AppBar';
import Tab from '@material-ui/core/Tab';
import Tabs from '@material-ui/core/Tabs';
import SettingsIcon from '@material-ui/icons/Settings';
import HistoryIcon from '@material-ui/icons/History';
import { Entity } from '@sketchpixy/rubix/lib/L20n';
import React from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import { initialize, submit } from 'redux-form';
import { COMPANY_NOTIFICATIONS_ATLAS_STATES, COMPANY_NOTIFICATIONS_BATTERY_LEVELS, COMPANY_NOTIFICATIONS_BATTERY_STATES, COMPANY_NOTIFICATIONS_CREDENTIALS_STATES, COMPANY_NOTIFICATIONS_ELEMENTS_USAGE_LEVELS, COMPANY_NOTIFICATIONS_ELEMENTS_USAGE_STATES, COMPANY_NOTIFICATIONS_GATEWAY_STATES, COMPANY_NOTIFICATIONS_REPEAT_STATES, PERMISSIONS, PERMISSION_ENTITIES } from '../../../_config/consts';
import AbilityProvider from '../../../permissionsUtils/AbilityProvider.js';
import * as ModalActions from '../../../redux/actions/modal.actions.js';
import * as PlatformUserActions from '../../../redux/actions/platformUsers.actions';
import * as InstallersActions from '../../../redux/actions/installers.actions.js';
import * as SettingsActions from '../../../redux/actions/setting.actions';
import * as UtilsActions from '../../../redux/actions/utils.actions';
import * as GuestActions from '../../../redux/actions/guest.actions';
import * as RolesActions from '../../../redux/actions/roles.actions';
import MDButton from '../../MDButton/MDButton.jsx';
import Permission from '../../Permission/Permission.jsx';
import SystemStatusReportForm from '../../forms/SystemStatusReportForm.jsx';
import CompanyNotificationsHistorySection from './CompanyNotificationsHistorySection.jsx';
import { isValidEmail } from '../../../_config/utils.js';

const styles = {
  container: {
  },
  boldText: {
    margin: 0,
    fontWeight: 'bold',
    color: '#3f3f3f',
  },
};

@connect((state) => ({form: state.form.SystemStatusReportForm, platformUsers: state.platformUsers, installers: state.installers, roles: state.roles, themeName: state.settings.items.theme.data.themeName}))
class SystemStatusReportOperationalSection extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      selectedTab: 0,
    };
  }

  async componentWillMount() {
    const { dispatch } = this.props;
    dispatch(UtilsActions.setSpinnerVisibile(true));
    let gatewayMode = COMPANY_NOTIFICATIONS_GATEWAY_STATES.OFF;
    let batteryMode = COMPANY_NOTIFICATIONS_BATTERY_STATES.OFF;
    let atlasMode = COMPANY_NOTIFICATIONS_ATLAS_STATES.OFF;
    let repeatMode = COMPANY_NOTIFICATIONS_REPEAT_STATES.OFF;
    let credentialsMode = COMPANY_NOTIFICATIONS_CREDENTIALS_STATES.OFF;
    let elementsUsageMode = COMPANY_NOTIFICATIONS_ELEMENTS_USAGE_STATES.OFF;
    let smartLockBatteryLevelSelected = COMPANY_NOTIFICATIONS_BATTERY_LEVELS.L75;
    let elementsUsageLevelSelected = COMPANY_NOTIFICATIONS_ELEMENTS_USAGE_LEVELS.L50;
    try {
      await this.onFetchAllRolesUsers();
      await dispatch(InstallersActions.fetchInstallers(0, 100));
      const response = await dispatch(SettingsActions.fetchSettingsByType('companyNotifications'));
      if (response && response.gatewayOfflineForMinutes && response.gatewayOfflineForMinutes>0)
        gatewayMode = COMPANY_NOTIFICATIONS_GATEWAY_STATES.ON      
      if (response && response.smartLockBatteryLevel && response.smartLockBatteryLevel>0){
        batteryMode = COMPANY_NOTIFICATIONS_BATTERY_STATES.ON
        smartLockBatteryLevelSelected = 
          response.smartLockBatteryLevel===25?COMPANY_NOTIFICATIONS_BATTERY_LEVELS.L25:
          response.smartLockBatteryLevel===50?COMPANY_NOTIFICATIONS_BATTERY_LEVELS.L50:
          COMPANY_NOTIFICATIONS_BATTERY_LEVELS.L75
      }
      if (response && response.atlasOffline)
        atlasMode = COMPANY_NOTIFICATIONS_ATLAS_STATES.ON
      if (response && response.sameNotificationAfterHours && response.sameNotificationAfterHours>0)
        repeatMode = COMPANY_NOTIFICATIONS_REPEAT_STATES.ON
      if (response && response.credentialsWillExpireInHours && response.credentialsWillExpireInHours>0)
        credentialsMode = COMPANY_NOTIFICATIONS_CREDENTIALS_STATES.ON
      if (response && response.elementsUsagePercentage && response.elementsUsagePercentage>0){
        elementsUsageMode = COMPANY_NOTIFICATIONS_ELEMENTS_USAGE_STATES.ON
        elementsUsageLevelSelected = 
          response.elementsUsagePercentage===50?COMPANY_NOTIFICATIONS_ELEMENTS_USAGE_LEVELS.L50:
          response.elementsUsagePercentage===60?COMPANY_NOTIFICATIONS_ELEMENTS_USAGE_LEVELS.L60:
          response.elementsUsagePercentage===70?COMPANY_NOTIFICATIONS_ELEMENTS_USAGE_LEVELS.L70:
          response.elementsUsagePercentage===80?COMPANY_NOTIFICATIONS_ELEMENTS_USAGE_LEVELS.L80:
          response.elementsUsagePercentage===90?COMPANY_NOTIFICATIONS_ELEMENTS_USAGE_LEVELS.L90:
          COMPANY_NOTIFICATIONS_ELEMENTS_USAGE_LEVELS.L50
      }

      // Costruzione dell'array emails combinando settings e utenti abilitati
      let combinedEmails = [];
      
      // Aggiungi le email dalle settings se esistono
      if (response && response.emails && Array.isArray(response.emails)) {
        combinedEmails = [...response.emails];
      }
      
      // Ottieni gli utenti che hanno companyNotificationsEnabled = true
      const { platformUsers, installers } = this.props;
      const platformUsersData = platformUsers?.data?.content || [];
      const installersData = installers?.data?.content || [];
      const allUsers = [...platformUsersData, ...installersData];
      
      // Aggiungi le email degli utenti abilitati alle notifiche
      const enabledUsersEmails = allUsers
        .filter(user => user.companyNotificationsEnabled && user.email)
        .map(user => user.email);
      
      combinedEmails = [...combinedEmails, ...enabledUsersEmails];
      
      dispatch(initialize('SystemStatusReportForm', { 
        ...response, 
        credentialsWillExpireInHours: (response.credentialsWillExpireInHours || 0) / 24,
        gatewayMode, 
        batteryMode, 
        atlasMode, 
        repeatMode, 
        credentialsMode,
        elementsUsageMode,
        smartLockBatteryLevelSelected,
        elementsUsageLevelSelected,
        emails: combinedEmails 
      }));
      dispatch(UtilsActions.setSpinnerVisibile(false));
    } catch(error) {
      dispatch(initialize('SystemStatusReportForm', { gatewayMode, batteryMode, atlasMode, repeatMode, credentialsMode, elementsUsageMode, smartLockBatteryLevelSelected, elementsUsageLevelSelected, emails: [] }));
      dispatch(UtilsActions.setSpinnerVisibile(false));
    }
  }

  async onFetchAllRolesUsers() {
    const { dispatch } = this.props;
    dispatch(UtilsActions.setViewLoading(true));
    dispatch(PlatformUserActions.resetPlatformUsersFilters());
    try {
      await dispatch(RolesActions.fetchRoles());
      const { roles: { roles: { content: rolesData } } } = this.props;
      const allRolesIds = _.map(_.filter(rolesData, r => r.id !== 5), role => role.id);
      dispatch(PlatformUserActions.setPlatformUsersFilter('roleIds', [allRolesIds]));
      await dispatch(PlatformUserActions.fetchPlatformUsers());
    } catch (error) {
      dispatch(PlatformUserActions.fetchPlatformUsers(0,100));
    } finally {
      dispatch(UtilsActions.setViewLoading(false));
    }
  }


  async saveCompanySettings(values) {
    const { dispatch, platformUsers, installers } = this.props;
    try {
      dispatch(UtilsActions.setSpinnerVisibile(true));
      
      // Ottieni tutti gli utenti (platformUsers + installers)
      const platformUsersData = platformUsers?.data?.content || [];
      const installersData = installers?.data?.content || [];
      const allUsers = [...platformUsersData, ...installersData];
      
      const userEmailsToEnable = [];
      const userEmailsToDisable = [];
      const genericEmails = [];
      
      if (values.emails && Array.isArray(values.emails)) {
        values.emails.forEach(email => {
          if (isValidEmail(email, true)) {
            const existingUser = allUsers.find(user => user.email === email);
            if (existingUser) {
              userEmailsToEnable.push(existingUser);
            } else {
              genericEmails.push(email);
            }
          }
        });
      }
      
      // Aggiorna notificationSettings
      const updatedValues = {
        ...values,
        emails: genericEmails
      };
      await dispatch(SettingsActions.updateNotificationsSettings(updatedValues));
      
      // Aggiornamento utenti (companyNotificationsEnabled)
      allUsers.forEach(user => {
        if (user.companyNotificationsEnabled && user.email) {
          const isStillInEmails = values.emails && values.emails.includes(user.email);
          if (!isStillInEmails)
            userEmailsToDisable.push(user);
        }
      });
      
      const platformUsersToEnable = userEmailsToEnable.filter(user => 
        platformUsersData.some(pu => pu.id === user.id)
      );
      const platformUsersToDisable = userEmailsToDisable.filter(user => 
        platformUsersData.some(pu => pu.id === user.id)
      );
      
      const installersToEnable = userEmailsToEnable.filter(user => 
        installersData.some(inst => inst.id === user.id)
      );
      const installersToDisable = userEmailsToDisable.filter(user => 
        installersData.some(inst => inst.id === user.id)
      );
      
      const userUpdatePromises = [];
      platformUsersToEnable.forEach(user => {
        userUpdatePromises.push(
          dispatch(GuestActions.updateGuest({
            ...user,
            companyNotificationsEnabled: true
          }, true))
        );
      });
      platformUsersToDisable.forEach(user => {
        userUpdatePromises.push(
          dispatch(GuestActions.updateGuest({
            ...user,
            companyNotificationsEnabled: false
          }, true))
        );
      });
      installersToEnable.forEach(user => {
        userUpdatePromises.push(
          dispatch(GuestActions.updateGuest({
            ...user,
            companyNotificationsEnabled: true
          }, true))
        );
      });
      installersToDisable.forEach(user => {
        userUpdatePromises.push(
          dispatch(GuestActions.updateGuest({
            ...user,
            companyNotificationsEnabled: false
          }, true))
        );
      });
      
      await Promise.all(userUpdatePromises);
      
      // Refresh
      await Promise.all([
        dispatch(PlatformUserActions.fetchPlatformUsers(0,100)),
        dispatch(InstallersActions.fetchInstallers(0, 100))
      ]);
      
      dispatch(UtilsActions.setSpinnerVisibile(false));
      dispatch(ModalActions.showModal({
        modalType: 'SUCCESS_ALERT',
        modalProps: {
          message: (<h6 className="snack-title"><Entity entity="settingUpdateSuccessfully" /></h6>),
        },
      }));
    } catch (error) {
      dispatch(UtilsActions.setSpinnerVisibile(false));
      dispatch(ModalActions.showModal({
        modalType: 'ERROR_ALERT',
        modalProps: {
          message: (<h6 className="snack-title"><Entity entity="settingUpdateError" /></h6>),
        },
      }));
    }
  }

  onSelectTab(tab) {
    this.setState({ selectedTab: tab });
  }

  render() {
    const { classes, dispatch, form, platformUsers: { data: { content: platformUsersData }}, user } = this.props;
    const { selectedTab } = this.state;

    const formData = form && form.values;

    const atLeastOneValidEmail = formData && formData.emails && formData.emails.length > 0 && formData.emails.some(e => isValidEmail(e, true));

    return (
      <div className={classes.container}>
        <div style={{ marginTop: 0 }}>
          <AppBar position="absolute" color="default" style={{ top: 65, zIndex: 10 }}>
            <Tabs
              value={selectedTab}
              textColor="primary"
              indicatorColor="primary"
              scrollable
              onChange={(e, index) => this.onSelectTab(index)}
              TabIndicatorProps={{
                style: { display: 'none' }
              }}
            >
              <Tab icon={<SettingsIcon style={{ fontSize: 26 }} />} label={<h5 style={{ margin: 0, fontWeight: 'bold' }}><Entity entity="hardwareStatusReportSettings" /></h5>} />
              <Tab icon={<HistoryIcon style={{ fontSize: 26 }} />} label={<h5 style={{ margin: 0, fontWeight: 'bold' }}><Entity entity="hardwareStatusReportHistory" /></h5>} />
            </Tabs>
          </AppBar>
        </div>
        <div style={{ position: 'absolute', top: 135, right: 0, left: 0, bottom: 0, display: selectedTab === 0 ? 'block' : 'none' }}>
          <div style={{ paddingLeft: 20, paddingRight: 25, height: '100%', overflowY: 'auto', paddingBottom: 60, paddingTop: 20 }}>
            <SystemStatusReportForm
              onSubmit={values => this.saveCompanySettings(values)}
            />
          </div>
          <div style={{ backgroundColor: 'white', position: 'absolute', left: 0, right: 0, bottom: 0, width: '100%', margin: 0 }}>
            <Permission do={[PERMISSIONS.UPDATE]} on={PERMISSION_ENTITIES.COMPANY} abilityHelper={AbilityProvider.getAbilityHelper()}>
              <MDButton
                containerStyle={{ position: 'absolute', left: 0, right: 0, bottom: 0, width: '100%', margin: 0 }}
                style={{ height: 45, borderRadius: 0, opacity: !atLeastOneValidEmail ? 0.7 : 1 }}
                title={<Entity entity="save" />}
                disabled={!atLeastOneValidEmail}
                onClick={() => dispatch(submit('SystemStatusReportForm'))}
              />
            </Permission>
          </div>
        </div>
        <div style={{ position: 'absolute', top: 135, right: 0, left: 0, bottom: 0, display: selectedTab === 1 ? 'block' : 'none' }}>
          <CompanyNotificationsHistorySection />
        </div>
      </div>
    );
  }
} 

export default withStyles(styles)(SystemStatusReportOperationalSection);
